import { addAPIProvider, disableCache } from '@iconify/vue';

/**
 * 设置图标库离线
 */
export function setupIconifyOffline() {
  const { VITE_ICONIFY_URL } = import.meta.env;

  if (VITE_ICONIFY_URL) {
    addAPIProvider('', { resources: [VITE_ICONIFY_URL] });

    disableCache('all');
  }
}
